var path = '/opt/atlassian/pipelines/agent/build/src/app/common/components/display-users-options/display-options.html';
var html = "<span> {{$ctrl.userType}} </span>";
window.angular.module('ng').run(['$templateCache', function(c) { c.put(path, html) }]);
module.exports = path;


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/display-users-options/display-options.html
// module id = 912
// module chunks = 0